"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ModernHotelsEngine() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  return <section ref={ref} aria-labelledby="modern-hotels-engine-title" className={`relative w-full bg-background text-foreground py-10 sm:py-14 transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <div className="relative mx-auto max-w-3xl px-6 sm:px-8">
        <h2 id="modern-hotels-engine-title" className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-foreground text-center mb-6">
          Why Modern Boutique Resorts Can't Run on Static Rates
        </h2>

        <p className="font-sans text-base sm:text-lg text-foreground font-normal leading-relaxed text-center sm:text-left">
          Independent hotels cannot afford flat rates. When OTAs apply stealth promotions and demand spikes without notice, static pricing leaves money behind on busy weekends and leaves rooms empty on midweeks. I track daily market pickup pace, monitor compset movement, and clean up channel manager connections to protect net ADR, improve{" "}
          <Link href="https://hotelrevbaba.com/the-ultimate-ota-listing-optimization-guide-how-small-hotels-with-30-rooms-or-fewer-can-boost-online-bookings/" className="underline text-secondary-foreground hover:text-foreground font-semibold transition-colors">
            OTA listing visibility
          </Link>
          , and keep your direct booking engine price-competitive.
        </p>
      </div>
    </section>;
}